import updateCart from '~/firebase/update/updateCart';
import taxTypeAtom from '~/recoil/atom/taxType';
import { useRecoilState } from 'recoil';
import useCartId from '~/hooks/useCartId';
import { PLATFORM_ID } from '~/globalVariables';
import { TaxType } from '~/types/cart';
import { useParams } from 'react-router-dom';

export default function useTaxType() {
  const { cartId } = useCartId();
  const { enterpriseGroupBuyId = '' } = useParams();

  const [taxType, setTaxType] = useRecoilState(taxTypeAtom);

  const handleChangeTaxType = async (type: TaxType) => {
    if (!cartId) {
      return;
    }

    try {
      await updateCart(PLATFORM_ID, cartId, {
        taxType: type,
      });
      if (!!enterpriseGroupBuyId) setTaxType(type);
    } catch (err) {
      console.error('update taxType error');
    }
  };

  return {
    taxType,
    handleChangeTaxType,
  };
}
